export default "Image Minipulation Workshop\n"